var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4839,
    cy: 24.8855,
    r: 24.3497,
    fill: "#0C1719"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.481 41.9986V33.2174L13.618 26.8654L24.481 41.9986Z",
    fill: "#F0CDC2",
    stroke: "#1616B4",
    strokeWidth: 0.1,
    strokeMiterlimit: 22.9245,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5174 41.9986V33.2174L35.379 26.8654L24.5174 41.9986Z",
    fill: "#C9B3F5",
    stroke: "#1616B4",
    strokeWidth: 0.1,
    strokeMiterlimit: 22.9245,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4811 31.0362V19.8287L13.4949 24.7485L24.4811 31.0362Z",
    fill: "#88AAF1",
    stroke: "#1616B4",
    strokeWidth: 0.1,
    strokeMiterlimit: 22.9245,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5174 31.0362V19.8287L35.5036 24.7485L24.5174 31.0362Z",
    fill: "#C9B3F5",
    stroke: "#1616B4",
    strokeWidth: 0.1,
    strokeMiterlimit: 22.9245,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4949 24.7485L24.4811 7V19.8287L13.4949 24.7485Z",
    fill: "#F0CDC2",
    stroke: "#1616B4",
    strokeWidth: 0.1,
    strokeMiterlimit: 22.9245,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5037 24.7485L24.5175 7V19.8287L35.5037 24.7485Z",
    fill: "#B8FAF6",
    stroke: "#1616B4",
    strokeWidth: 0.1,
    strokeMiterlimit: 22.9245,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEas);
export default __webpack_public_path__ + "static/media/iconEas.450241861678099c9e6634265646a9e2.svg";
export { ForwardRef as ReactComponent };